import {
  FileTextFilled,
  TeamOutlined,
  FileDoneOutlined,
  ReconciliationFilled,
  HddOutlined,
  AppstoreAddOutlined,
} from "@ant-design/icons";
import { TbReportMoney, TbReportAnalytics } from "react-icons/tb";
import { RiTeamFill } from "react-icons/ri";
import { MdOutlineDashboard } from "react-icons/md";
import { TiThLarge } from "react-icons/ti";
import { TfiTruck } from "react-icons/tfi";
import { LuBox } from "react-icons/lu";
import { BsShop } from "react-icons/bs";
let _nav = [
  {
    title: "DATA",
    type: "group",
  },
  {
    title: "หน้าหลัก",
    icon: <MdOutlineDashboard className="nav-ico" />,
    to: "/dashboard",
  },
  {
    title: "SELL",
    type: "group",
  },
  {
    title: "ใบขายสินค้า",
    icon: <ReconciliationFilled className="nav-ico" />, 
    to: "/sales-order",
  },
  {
    title: "ใบส่งของ",
    icon: <TfiTruck className="nav-ico" />,
    to: "/delivery-note",
  },
  {
    title: "ใบแจ้งหนี้",
    icon: <ReconciliationFilled className="nav-ico" />,
    to: "/invoice",
  },  
  {
    title: "ใบเสร็จรับเงิน",
    icon: <TbReportMoney className="nav-ico" />,
    to: "/receipt",
  },
  {
    title: "ข้อมูลลูกค้า",
    icon: <RiTeamFill className="nav-ico" />,
    to: "/customers",
  },
  {
    title: "REPORT",
    type: "group",
  },
  {
    title: "รายการสั่งซื้อตามสาขา",
    icon: <TbReportAnalytics className="nav-ico" />,
    to: "/report/order-items-by-branch",
  },
  {
    title: "BUY",
    type: "group",
  },
  {
    title: "ใบสั่งซื้อ",
    icon: <FileTextFilled className="nav-ico" />, 
    to: "/purchase-order",
  },
  {
    title: "ใบรับสินค้า",
    icon: <FileDoneOutlined className="nav-ico"/>, 
    to: "/goods-receipt",
  },  
  {
    title: "ข้อมูลผู้ขาย",
    icon: <BsShop className="nav-ico" />,
    to: "/supplier",
  },
  {
    title: "MASTER",
    type: "group",
  },
  {
    title: "ข้อมูลสินค้า",
    icon: <LuBox className="nav-ico" />,
    to: "/items",
  },
  {
    title: "แคตตาล็อก",
    icon: <AppstoreAddOutlined className="nav-ico" />,
    to: "/catalog",
  },
  {
    title: "ประเภทสินค้า",
    icon: <TiThLarge className="nav-ico" />,
    to: "/itemtype",
  },
  {
    title: "หน่วยสินค้า",
    icon: <HddOutlined className="nav-ico" />,
    to: "/unit",
  },
  {
    title: "ผู้ใช้งาน",
    icon: <TeamOutlined className="nav-ico" />,
    to: "/users",
  },
];

export default _nav;
